import type { ProblemDetails } from "@rema/shared"
import type { FieldValues, Path, UseFormSetError } from "react-hook-form"
import { errorMessage, es } from "../i18n/es"

// Mapeo 1:1 de los `errors[]` de un `validation_error` (docs/04 §1) a los Field
// de react-hook-form: cada campo inválido se pinta en rojo con su helper text.
// Devuelve true si se aplicó al menos un error de campo; si devuelve false, el
// caller muestra el problema en un MessageBar DENTRO del formulario (nunca toast).
export const applyFieldErrors = <T extends FieldValues>(
  problem: ProblemDetails,
  setError: UseFormSetError<T>,
): boolean => {
  const errors = problem.errors ?? []
  errors.forEach((fieldError, index) => {
    setError(
      fieldError.field as Path<T>,
      { type: fieldError.code, message: fieldError.message },
      // El foco salta al primer campo inválido (docs/05 §3)
      { shouldFocus: index === 0 },
    )
  })
  return errors.length > 0
}

// Mensaje para errores NO mapeables a campos (invalid_credentials, account_locked…):
// prioriza el detail del servidor (ya viene en español) y cae al diccionario local.
export const problemMessage = (problem: ProblemDetails): string => {
  if (problem.status === 0) return es.errors.network
  return problem.detail ?? errorMessage(problem.code)
}
